import { call, select } from 'redux-saga/effects';
import { IntelligentPhotoCaptureAttachmentIterationStatus } from '../enums';
import { getAttachmentIterationInfo } from '../selectors';
import { attachmentIteration } from '../utilities';
import { batchChain, getImageBatchConfig } from './intelligentPhotoCaptureImageBatchProcessingSaga';
export function* intelligentPhotoCaptureCameraCompleteIterationSaga(iteration) {
    if (!iteration ||
        iteration.uploadingStatus !== IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED ||
        !attachmentIteration.areAllCameraFilesCompleted(iteration)) {
        return;
    }
    const { iterationFiles, uploadFailedCount = 0 } = iteration;
    const imageBatchConfig = yield call(getImageBatchConfig);
    if ((iterationFiles.length - uploadFailedCount) % imageBatchConfig.batchSize !== 0) {
        yield call([batchChain, batchChain.flushRemainingBatch], imageBatchConfig);
    }
}
export function* intelligentPhotoCaptureUpdateIterationUploadingStatusSaga(action) {
    const iterationInfoList = (yield select(getAttachmentIterationInfo));
    const iteration = iterationInfoList.find((item) => item.iterationId === action.payload.iterationId);
    yield call(intelligentPhotoCaptureCameraCompleteIterationSaga, iteration);
}
//# sourceMappingURL=intelligentPhotoCaptureUpdateIterationUploadingStatusSaga.js.map